const TIN_ACTION_TYPES = {
  LOAD_TIN: 'tin/LOAD_TIN',
};

export default TIN_ACTION_TYPES;
